import { z } from "zod";

export const emailSchema = z.object({
  email: z
    .string()
    .email({ message: "Invalid email address." })
    .trim()
    .min(1, { message: "Email is required." })
    .max(255, { message: "Email is too long." }),
});

export type EmailInput = z.infer<typeof emailSchema>;
